import { RegistryItem } from "@schemas/agreements/schema";
import BlockFreightAgreementForm from "view/agreements/components/form/BlockFreightAgreementForm";
import BlockFreightAgreementDetails from "view/agreements/components/details/BlockFreightAgreementDetails";
import { AgreementTypeEnum, CalculationMethodType } from "__generated__/graphql";

export const BlockFreightSchema: RegistryItem = {
	[AgreementTypeEnum.BlockFreight]: {
		Form: BlockFreightAgreementForm,
		Details: BlockFreightAgreementDetails,
		defaultValues: {
			calculationMethod: {
				type: CalculationMethodType.Lumpsum,
			},
		},
		agreementFields: {
			"agreement.days": { path: "days", rules: { required: true } },
			"agreement.manualActionRequired": { rules: { hidden: true } },
			"agreement.conditions": { rules: { hidden: true } },
		},
		calculationMethodFields: {
			"calculationMethod.type": { rules: { hidden: true } },
		},
		toInput: (form) => ({
			days: form.days,
		}),
		toForm: (agreement) => ({
			days: agreement.days ?? undefined,
		}),
	},
};
